module.exports = __webpack_public_path__ + "img/img8.ace7026b.png";